"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AndOptions = void 0;
var vue_1 = require("vue");
var PlayerInputFactory_1 = require("./PlayerInputFactory");
var Button_1 = require("../components/common/Button");
var i18n_1 = require("../directives/i18n");
exports.AndOptions = vue_1.default.component('and-options', {
    props: {
        player: {
            type: Object,
        },
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {};
    },
    methods: {
        saveData: function () {
            for (var i = 0; i < this.$data.childComponents.length; i++) {
                var componentInstance = this.$data.childComponents[i]
                    .componentInstance;
                if (componentInstance !== undefined) {
                    if (componentInstance.saveData instanceof Function) {
                        componentInstance.saveData();
                    }
                }
            }
            var res = [];
            if (this.playerinput.options !== undefined) {
                for (var i = 0; i < this.playerinput.options.length; i++) {
                    res.push(this.$data.responded['' + i]);
                }
            }
            this.onsave(res);
        },
    },
    render: function (createElement) {
        var _this = this;
        var playerInput = this.playerinput;
        var children = [];
        this.$data.childComponents = [];
        this.$data.responded = [];
        if (this.showtitle) {
            children.push(createElement('div', { 'class': 'wf-title' }, i18n_1.$t(playerInput.title)));
        }
        if (playerInput.options !== undefined) {
            var options = playerInput.options;
            options.forEach(function (option, idx) {
                if (_this.$data.responded[idx] === undefined) {
                    children.push(new PlayerInputFactory_1.PlayerInputFactory().getPlayerInput(createElement, _this.players, _this.player, option, function (out) {
                        _this.$data.responded[idx] = out[0];
                    }, false, true));
                    _this.$data.childComponents.push(children[children.length - 1]);
                }
            });
        }
        if (this.showsave) {
            var saveBtn = createElement(Button_1.Button, {
                props: {
                    title: playerInput.buttonLabel,
                    type: 'submit',
                    size: 'normal',
                    onClick: function () {
                        _this.saveData();
                    },
                },
            });
            children.push(createElement('div', { 'class': 'wf-action' }, [saveBtn]));
        }
        return createElement('div', { 'class': 'wf-options' }, children);
    },
});
//# sourceMappingURL=AndOptions.js.map